import React from 'react'
import Page from '../Page'
import TitlePage from '../TitlePage'
import { Pagination, Skeleton } from '@mui/material'

export default function ListLayout({ title, action, loading, head, body, pagination, id, setSearchParams }) {
    let tr = []
    let td = []

    for (let i = 0; i < body?.length; i++) {
        for (let index = 0; index < Object.keys(body[i]).length - 1; index++) {
            td.push(<td key={index} class="text-center" style={{ color: head[0] === '' && index === 0 ? 'limegreen' : 'inherit' }}>{body[i][`item${index + 1}`]}</td>)
        }
        tr.push(
            <tr key={i} className={id === body[i]?.id ? 'active' : ''}>
                {td}
            </tr >)
        td = []

    }
    return (
        <Page>
            <TitlePage title={title} action={action} />
            <div class="receive-list row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    {head?.map((item, i) => {
                                        return (
                                            <th key={i} class="text-center">{item}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody class="">
                                {tr}
                            </tbody >
                        </table >
                    </div >}
                <div class="col-md-12 text-center mt-4">
                    <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={pagination?.count} page={pagination?.page} onChange={(event, value) => {
                        setSearchParams({ page: value, ...pagination?.event })}} shape="rounded" />
                </div>
            </div >
        </Page>
    )
}
